var map = {
	"./en/Common.json": "0a2d",
	"./en/Core/Footer.json": "173d",
	"./en/Core/Toolbar.json": "f26b4",
	"./en/Home.json": "5cc69",
	"./en/Reports/AlertTracking.json": "7560c",
	"./en/Reports/HourByHour.json": "0f2b",
	"./en/Reports/IncidentReport.json": "52b7",
	"./en/Reports/MachineUsage.json": "ed70",
	"./en/Reports/OEEShift.json": "ba65",
	"./en/Reports/ProductionPlan.json": "1a57",
	"./en/Reports/RealtimeSensors.json": "a37c",
	"./es/Reports/AlertTracking.json": "666e",
	"./es/Reports/HourByHour.json": "1849",
	"./es/Reports/IncidentReport.json": "d9e26",
	"./es/Reports/MachineUsage.json": "66a4",
	"./es/Reports/OEEShift.json": "3474",
	"./es/Reports/ProductionPlan.json": "3ea8",
	"./es/Reports/RealtimeSensors.json": "04a0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4999";